export default "__VITE_ASSET__DBQfegDN__"